import moment from 'moment';
import Cookies from 'universal-cookie';

const postPresenceClockOutPayload = (formData) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  return {
    operatorPresenceId: formData?.monitoringStatus?.presence?.id,
    endedAt: moment.tz(timezone).format('YYYY-MM-DD HH:mm:ss'),
  };
};

export default postPresenceClockOutPayload;
